import { formatInvoicePayUrlDisplay } from "@common/helpers/invoice-pay-url.helper";

const PREVIEW_PAY_TOKEN = "…";

export function resolveNativeInvoiceEmailPayUrl({
    isCollectPaymentOn,
    paymentToken,
    origin,
}: {
    isCollectPaymentOn: boolean;
    paymentToken: string | null | undefined;
    origin: string;
}): string | null {
    if (!isCollectPaymentOn) {
        return null;
    }
    return `${origin}/pay/${paymentToken ?? PREVIEW_PAY_TOKEN}`;
}

export { formatInvoicePayUrlDisplay };
